
export const campaignValues = {
    "Event": "vet_event",
    "Facebook": "facebook",
    "Google" : "google",
    "Instagram": "instagram",
    "Referred by family/friend": "referral",
    "Referred by VBG employee": "self_generated",
    "Web Search": "other",
    "VBG Website": "website",
    "MCON": "vet_event",
    "Merging Vets and Players": "vet_event",
    "Military Times": "vet_event",
    "SNVCC": "vet_event",
    "Vegas Chamber": "vet_event",
    "Vegas Golden Knights": "vgk",
    "Veteran Social Club": "vet_event",
    "Other": "other",
    /*
    "Armed Forces & Military First Responders": "armed_forces_and_military_first_responders",
    "Army Navy Game": "army_navy_game",
    "Benefits.com": "benefits.com", //switch to benefits_dot_com
    "Bing": "bing",
    "Fellow Veteran": "fellow_veteran",
    "Friends/Family": "friends/family", //switch to friends_family
    "Hire GI": "hire_gi",
    "Irreverent Warriors": "irreverent_warriors",
    "Kline Veterans Fund": "kline_veterans_fund",
    "LinkedIn": "linkedin",
    "MOPH Chapter 711": "moph_chapter_711",
    "MSEP": "msep",
    "Military Bowl": "military_bowl",
    "Military Influencer Conference": "military_influencer_conference",
    "Military Makeover": "military_makeover",
    "PGA Hope": "pga_hope",
    "Professional Bull Riders": "professional_bull_riders",
    "Radio": "radio",
    "SD Business Journal": "sd_business_journal",
    "SDMAC": "sdmac",
    "Student Veterans of America": "student_veterans_of_america",
    "The Hill Summit": "the_hill_summit",
    "UNLV": "unlv",
    "UNLV Rebel Vets": "unlv_rebel_vets",
    "US4Warriors": "us4warriors",
    "VECA": "veca",
    "VFW Post 12198": "vfw_post_12198",
    "Veteran Tickets": "veteran_tickets",
    "Women Veterans Alliance": "women_veterans_alliance",
    "Yahoo": "yahoo"

     */
}

export const campaignDetailValues = {
    "Event": "",
    "Facebook": "",
    "Google" : "",
    "Instagram": "",
    "Referred by family/friend": "",
    "Referred by VBG employee": "",
    "Web Search": "Web Search",
    "VBG Website": "",
    "MCON": "",
    "Merging Vets and Players": "",
    "Military Times": "Military Times",
    "SNVCC": "",
    "Vegas Chamber": "Vegas Chamber",
    "Vegas Golden Knights": "",
    "Veteran Social Club": "Veterans Social Club",
    "Other": "",
    /*
    "Armed Forces & Military First Responders": "armed_forces_and_military_first_responders",
    "Army Navy Game": "army_navy_game",
    "Benefits.com": "benefits.com", //switch to benefits_dot_com
    "Bing": "bing",
    "Fellow Veteran": "fellow_veteran",
    "Friends/Family": "friends/family", //switch to friends_family
    "Hire GI": "hire_gi",
    "Irreverent Warriors": "irreverent_warriors",
    "Kline Veterans Fund": "kline_veterans_fund",
    "LinkedIn": "linkedin",
    "MOPH Chapter 711": "moph_chapter_711",
    "MSEP": "msep",
    "Military Bowl": "military_bowl",
    "Military Influencer Conference": "military_influencer_conference",
    "Military Makeover": "military_makeover",
    "PGA Hope": "pga_hope",
    "Professional Bull Riders": "professional_bull_riders",
    "Radio": "radio",
    "SD Business Journal": "sd_business_journal",
    "SDMAC": "sdmac",
    "Student Veterans of America": "student_veterans_of_america",
    "The Hill Summit": "the_hill_summit",
    "UNLV": "unlv",
    "UNLV Rebel Vets": "unlv_rebel_vets",
    "US4Warriors": "us4warriors",
    "VECA": "veca",
    "VFW Post 12198": "vfw_post_12198",
    "Veteran Tickets": "veteran_tickets",
    "Women Veterans Alliance": "women_veterans_alliance",
    "Yahoo": "yahoo"

     */
}

export const partnershipValues = {
    "Event": "",
    "Facebook": "",
    "Google" : "",
    "Instagram": "",
    "Referred by family/friend": "",
    "Referred by VBG employee": "",
    "Web Search": "",
    "VBG Website": "",
    "MCON": "mcon",
    "Merging Vets and Players": "mvp",
    "Military Times": "",
    "SNVCC": "snvcc",
    "Vegas Chamber": "",
    "Vegas Golden Knights": "vgk",
    "Veteran Social Club": "",
    "Other": "",
    /*
    "Armed Forces & Military First Responders": "armed_forces_and_military_first_responders",
    "Army Navy Game": "army_navy_game",
    "Benefits.com": "benefits.com", //switch to benefits_dot_com
    "Bing": "bing",
    "Fellow Veteran": "fellow_veteran",
    "Friends/Family": "friends/family", //switch to friends_family
    "Hire GI": "hire_gi",
    "Irreverent Warriors": "irreverent_warriors",
    "Kline Veterans Fund": "kline_veterans_fund",
    "LinkedIn": "linkedin",
    "MOPH Chapter 711": "moph_chapter_711",
    "MSEP": "msep",
    "Military Bowl": "military_bowl",
    "Military Influencer Conference": "military_influencer_conference",
    "Military Makeover": "military_makeover",
    "PGA Hope": "pga_hope",
    "Professional Bull Riders": "professional_bull_riders",
    "Radio": "radio",
    "SD Business Journal": "sd_business_journal",
    "SDMAC": "sdmac",
    "Student Veterans of America": "student_veterans_of_america",
    "The Hill Summit": "the_hill_summit",
    "UNLV": "unlv",
    "UNLV Rebel Vets": "unlv_rebel_vets",
    "US4Warriors": "us4warriors",
    "VECA": "veca",
    "VFW Post 12198": "vfw_post_12198",
    "Veteran Tickets": "veteran_tickets",
    "Women Veterans Alliance": "women_veterans_alliance",
    "Yahoo": "yahoo"

     */
}




export const VGKFields = [
    "Vegas Golden Knights",
    "Professional Bull Riders",
    "UNLV",
    "Hire GI",
    "Military Makeover",
    "Women Veterans Alliance",
    "SNVCC",
    "Veteran Social Club",
    "MCON",
    "Military Influencer Conference",
    "Merging Vets and Players",
    "LinkedIn",
    "Facebook",
    "Fellow Veteran",
    "Friends/Family",
    "Yahoo",
    "Bing",
    "Radio",
    "PGA HOPE",
    "Military Bowl",
    "Army Navy Game",
    "Veteran Tickets",
    "Student Veterans of America",
    "Google"
]

